import styled from 'styled-components';

export const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
